/**
 * Environment configuration for the client application
 * Provides centralized access to environment variables with fallback defaults
 */

interface EnvConfig {
  // API Configuration
  API_URL: string
  WS_URL: string

  // Crypto Configuration
  CRYPTO_SALT: string
  PBKDF2_ITERATIONS: number
}

/**
 * Parse environment variables with fallback defaults
 * Defaults are matched with server configuration
 */
function parseEnv(): EnvConfig {
  return {
    // API Configuration
    API_URL: import.meta.env.VITE_API_URL || "http://localhost:3000/api",
    WS_URL: import.meta.env.VITE_WS_URL || "ws://localhost:3000",

    // Crypto Configuration - matches server defaults
    CRYPTO_SALT: import.meta.env.VITE_CRYPTO_SALT || "salt",
    PBKDF2_ITERATIONS: Number(import.meta.env.VITE_PBKDF2_ITERATIONS) || 100000,
  }
}

/**
 * Singleton environment configuration instance
 */
export const env = parseEnv()

/**
 * Validate critical environment variables
 */
export function validateEnv(): void {
  const criticalVars = {
    API_URL: env.API_URL,
    WS_URL: env.WS_URL,
  }

  for (const [key, value] of Object.entries(criticalVars)) {
    if (!value) {
      console.warn(`Warning: ${key} is not set. Using default value.`)
    }
  }
}
